import React from 'react';
import { formatDate } from 'utils/date';
import { differenceInDays } from 'date-fns';
import RenderLink from 'components/RenderLink';
import { CAR_INSURANCE } from 'constants/routeConstants';
import trackEvent from 'services/AnalyticsService';
import styles from '../Screens/CarInsurance.module.scss';
import InsuranceSummaryFullDetails from './InsuranceSummaryFullDetails';

type Props = {
  setIndicativeImageModal: () => void;
  setAutoUpdateContentModal: (_date: string) => void;
  details: WebExperienceApiContract.Models.CarinsurancePolicy;
};

const InsuranceSummaryCard = ({ setIndicativeImageModal, setAutoUpdateContentModal, details }: Props) => {
  const getStatusProps = (status: 'expired'
    | 'active'
    | 'renewal'
    | 'cancelled', renewalDate: string | '') => {
    const daysUntilRenewal = differenceInDays(
      new Date(renewalDate),
      new Date(),
    );

    if (status === 'cancelled') return { color: styles.greyBorder, text: 'Cancelled', bannerStyle: styles.greyBanner }
    if (status === 'expired' || daysUntilRenewal < 0) return { color: styles.greyBorder, text: 'Expired', bannerStyle: styles.greyBanner }
    if (status === 'renewal') return { color: styles.redBorder, text: `Due for renewal in ${daysUntilRenewal} days`, bannerStyle: styles.redBanner }
    return { color: styles.greenBorder, text: '', bannerStyle: '' }
  }

  const { text, color, bannerStyle } = getStatusProps(details.status, details.renewalDate)

  const onAutoUpdatedClick = () => {
    trackEvent('MyRAC_CarInsurance_Auto_Updated_Modal')
    setAutoUpdateContentModal(details.autoUpdatedDate);
  }

  const onIndicativeImageClick = () => {
    trackEvent('MyRAC_CarInsurance_Indicative_Image_Modal')
    setIndicativeImageModal()
  }

  if (!details) return null;
  return (
    <div className={`${styles.cardContainer} ${color}`}>
      {text
        ? (
          <div className={`${styles.banner} ${bannerStyle} pt-3 pb-3 ps-3`}>{text}</div>
        ) : null}
      <div className={`${styles.pageTitle} pb-3 pt-3 ps-3`}>RAC Online Car Insurance</div>

      <div className="row ps-3">
        <div className="col-6">
          <h3 className={styles.mainSectionTitle}>Renewal date</h3>
          <p>{formatDate(details.policyEndDate, 'd MMM yyyy')}</p>
          <h3 className={styles.mainSectionTitle}>Policy Number</h3>
          <p>{details?.policyNumber}</p>
          <h3 className={styles.mainSectionTitle}>Policy Holder</h3>
          <p>
            {details?.title} {details?.surname}
          </p>
        </div>
        <div className="col-6">
          <h3 className={`pb-3 ${styles.mainSectionTitle}`}>Car Covered</h3>
          <span className={`label rounded px-4 ${styles.numberPlate}`}>{details.vrn.toUpperCase()}</span>
          <img src={details.vehicleImage} alt="car" className="rounded mx-auto d-block img-fluid" />
        </div>
      </div>
      <div className="row pt-3 ps-3">
        <div className="col-6">
          <RenderLink
            onClick={onAutoUpdatedClick}
            url={CAR_INSURANCE}
            className={`float-left ${styles.actionLink}`}
          >
            Auto Updated on {formatDate(details.autoUpdatedDate, 'd MMM yyyy')}
          </RenderLink>
        </div>
        <div className="col-6 pe-4">
          <RenderLink onClick={onIndicativeImageClick} url={CAR_INSURANCE} className={`float-right ${styles.actionLink}`}>
            Indicative image
          </RenderLink>
        </div>
      </div>
      <hr className={`${styles.divider} ms-3 me-3`} />
      <InsuranceSummaryFullDetails details={details} />
    </div>
  );
};
export default InsuranceSummaryCard;
